// Navigation
$('#menu-toggle').click(function () {
    var $body = $('body'),
        $menu = $('.nav-container'),
        $hamburger = $('.hamburger');
    $body.toggleClass('menu-open')
    if ($body.hasClass('menu-open')) {
        $menu.addClass('menu-active');
        $hamburger.addClass('is-active');
    } else {
        $menu.removeClass('menu-active');
        $hamburger.removeClass('is-active');
    }
});

$(document).ready(function () {
    // Map Code
    if ($('#map').length) {
        makeMap();
    }

    if ($('.alert.alert-bar').length) {
        watchAlert();
    }

    if ($('.faq-list').length) {
        watchFaqs();
    }

    if ($('.header-container .search-btn').length) {
        watchSearch();
    }
});

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function watchSearch() {
    let $targetBtn = $('.header-container').children('.search-btn:not(input)');
    let $targetEle = $('.form-container.header-form-container');
    let $hiddenEle = $targetEle.children('#SearchForm_SearchForm');

    $targetEle.hide();
    $hiddenEle.hide();

    $targetBtn.on('click', function (event) {
        event.preventDefault()
        $targetEle.toggleClass('active');

        if (!$targetEle.hasClass('active')) {
            $hiddenEle.hide();
            let height = $targetEle.height()
            $targetEle.height(height).height(0)
            window.setTimeout(function () {
                $targetEle.hide().height('');
            }, 250);
        } else {
            $targetEle.show()
            window.setTimeout(function () {
                $targetEle.height(0).height(125);
            }, 250);
            window.setTimeout(function () {
                $hiddenEle.show()
            }, 450);
        }
    });
}

function watchFaqs() {
    let $faqList = $('.faq-list');
    let $faqs = $faqList.children('.faq');

    $faqs.each(function () {
        $(this).removeClass('unfold');
        $(this).children('.faq-content').hide();
    });

    $faqs.on('click', function () {
        let $target = $(this).children('.faq-content');
        $(this).siblings('.unfold').trigger('click')

        $(this).toggleClass('unfold')

        if ($(this).hasClass('unfold')) {
            $target.show()
            let height = $target.height()
            $target.height(0).height(height)
            window.setTimeout(function () {
                $target.height('')
            }, 250)
        } else {
            let height = $target.height()
            $target.height(height).height(0)
            window.setTimeout(function () {
                $target.hide().height('')
            }, 250)
        }
    });
}

function watchAlert() {
    let $alertBar = $('.alert.alert-bar');
    let $closeBtn = $alertBar.find('.close-btn').first();

    $closeBtn.on('click', function () {
        $alertBar.slideUp()
        setCookie('alert-hidden', $alertBar.data('hash'), 1)
    });
}

var map;

function makeMap() {
    let $mapEle = $('.practices-map');
    let $data = $mapEle.data('practice');
    let $locationType = $mapEle.data('location-type');

    $.ajax({
        url: '/Practice/getPractices',
        method: 'POST',
        data: {$data: $data, $locationType: $locationType},
        dataType: 'json',
        success: function ($data) {
            let $result = JSON.parse(JSON.stringify($data));

            if (Object.keys($result).length === 1) {
                $.each($result, function (i, val) {
                    map = L.map('map').setView([val['lat'], val['long']], 15)
                    let myFeatureGroup = L.featureGroup().addTo(map).on('click', flyOver);

                    let ch = $data;
                    let marker = L.marker([val['lat'], val['long']]).addTo(myFeatureGroup)
                        .bindPopup('<span class="sub-heading">' + val['title'] + '</span>');
                    marker.ch = ch;
                });
            } else {
                map = L.map('map').setView([-42.372049, 170.740266], 7);
                let myFeatureGroup = L.featureGroup().addTo(map).on('click', flyOver);

                $.each($result, function (i, val) {
                    let ch = $data;
                    let marker = L.marker([val['lat'], val['long']]).addTo(myFeatureGroup)
                        .bindPopup('<span class="sub-heading">' + val['title'] + '</span><br>' +
                            '<a href="/' + i + '">Click here to learn more.' + '</a>');
                    marker.ch = ch;
                });
            }

            L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                maxZoom: 19,
                attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
            }).addTo(map);

            let $southWest = L.latLng(-52.02545860348813, 158.0712890625),
                $northEast = L.latLng(-30.939924331023455, 189.44824218750003);

            let $bounds = L.latLngBounds($southWest, $northEast);

            map.setMaxBounds($bounds);
            map.setMinZoom(5);
        }
    });
}

function flyOver(event) {
    map.flyTo([event.layer.getLatLng().lat, event.layer.getLatLng().lng], 15);
}

$(document).on('scroll', function () {
    $('.animate').not('.run').each(function () {
        if ($(this).offset().top < $(document).scrollTop() + window.innerHeight) $(this).addClass('run')
    })
}).trigger('scroll')
